import { FC } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import {
	getDashboardServices,
	getDashboardServicesLoader,
} from 'redux/reducers/dashboard/selectors';
import { PATHS } from 'routes/constants';
import { PpwrBanner } from './PpwrBanner';
import { PpwrSkeleton } from './PpwrLayout';

export const EprPpwr: FC = () => {
	const dashboardServices = useSelector(getDashboardServices);
	const dashboardServicesIsLoad = useSelector(getDashboardServicesLoader);

	if (dashboardServicesIsLoad && !dashboardServices) return <PpwrSkeleton />;

	if (dashboardServices?.ppwrEnabled)
		return <Navigate to={PATHS.PPWR_MANUAL_REPORT_PAGE} replace />;

	return <PpwrBanner />;
};
